import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusIcon',
})
export class StatusIconPipe implements PipeTransform {
  transform(status: string | boolean | undefined, verbose?: boolean): string {
    return statusIcon(status, verbose);
  }
}

export function statusIcon(status: string | boolean | undefined, verbose = false): string {
  const conditionSucceed = (typeof status === 'boolean' && status) || status === 'success';
  const icon = conditionSucceed ? '✅' : '❌';
  if (verbose) {
    return `${icon} ${conditionSucceed ? 'Passed' : 'Failed'}`;
  }
  return icon;
}
